import { render, staticRenderFns } from "./AncillarySeatMapPassenger.vue?vue&type=template&id=2fd134d8&scoped=true"
import script from "./AncillarySeatMapPassenger.vue?vue&type=script&lang=js"
export * from "./AncillarySeatMapPassenger.vue?vue&type=script&lang=js"
import style0 from "./AncillarySeatMapPassenger.vue?vue&type=style&index=0&id=2fd134d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd134d8",
  null
  
)

export default component.exports